module.exports = __webpack_public_path__ + "img/Tajikistan.2acea9be.png";